import {useEventsSearchApi, UseEventsSearchApiOptions} from '@domain/shifthandover'
import {StoppageEvent} from '@hconnect/common/stoppages/types/stoppage.types'
import {shifthandoverStoppagesList, FilterTimeRange, EventSearchDto} from '@hconnect/common/types'

type ShiftEventStoppagesResult = {
  currentPage: number
  events: StoppageEvent[]
  totalItemCount: number
  totalPages: number
}

type UseShiftEventStoppagesOptions = Omit<UseEventsSearchApiOptions, 'select'>

export const useShiftEventStoppages = (
  plantId: string,
  timeRange: FilterTimeRange,
  pageNumber = 0,
  itemsPerPage = 50,
  pxTrendTag: string,
  options?: UseShiftEventStoppagesOptions
) => {
  return useEventsSearchApi(
    {
      plantId,
      criteria: {
        timeRange,
        pageNumber,
        itemsPerPage,
        eventType: shifthandoverStoppagesList,
        pxTrendTags: [pxTrendTag]
      }
    },
    {
      ...options,
      select: mapToShiftEventStoppagesResult
    }
  )
}

// Narrows EventSearchDto to StoppageEvent[] since we filter by shifthandoverStoppagesList event types
const mapToShiftEventStoppagesResult = (data: EventSearchDto) => data as ShiftEventStoppagesResult
